import { useChartColors } from './useChartColors';
import { useChartTooltip } from './useChartTooltip';
import { useChartLegend } from './useChartLegend';
import { useChartAxis } from './useChartAxis';
import { chartStyles } from './chartStyles';

/**
 * Comprehensive hook that provides all common chart configurations
 * Combines colors, tooltip, legend, axis styling, and common styles
 * @returns All chart configuration objects in one convenient hook
 */
export const useChartConfig = () => {
  const colors = useChartColors();
  const tooltip = useChartTooltip();
  const legend = useChartLegend();
  const axis = useChartAxis();

  return {
    colors,
    tooltip,
    legend,
    axis,
    styles: chartStyles,
  };
};
